<template>
  <v-container fluid v-resize="onResize">
    <v-card
      :loading="loading"
      :height="windowSize.y * 0.9 - subtractHeight"
    >
      <v-card-title class="text-center justify-center align-center">Holidays</v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle ref="RefListTop" height="128">
          <v-container fluid>
                <v-text-field type="month" v-model="current_date" clearable label="Date" @input="onUpdateFilters()"></v-text-field>
          </v-container>
        </v-card-subtitle>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr><td>Previous year total</td><td>{{ item.holiday_prev_total }}</td></tr>
              <tr><td>Previous year spent</td><td>{{ item.holiday_prev_spend }}</td></tr>
              <tr><td>Total in current year</td><td>{{ item.holiday_current_total }}</td></tr>
              <tr><td>Spend in current year</td><td>{{ item.holiday_current_spend }}</td></tr>
              <tr><td>Planing but not spent in current year</td><td>{{ item.holiday_current_plan }}</td></tr>
              <tr><td>Available in current year</td><td>
                {{ item.holiday_current_available }}
              </td></tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
    <router-view></router-view>
  </v-container>
</template>
<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';


export default {
  name: 'CalendarDateUserStatisticBeginOne',
  props: {
    subtractHeight: {type: [Number], default: 200},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserStatisticBeginDTO'},
  },

  components: {
  },

  computed: {
    ...mapGetters('CalendarDateUserStatisticBegin', ['getColumns']),
    ...mapFields('CalendarDateUserStatisticBegin', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),

    item() {
      if (this.itemList.length > 0)
        return this.itemList[0]
      else
        return {}
    },
  },
  methods: {
    ...mapActions('CalendarDateUserStatisticBegin', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, )
      this.options.page = 1

      this.filters = {}

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      if (this.current_date) {
        console.log('current_date', this.current_date)
        this.filters['current_date'] = this.current_date + '-01'
      }
      else
        this.filters['current_date'] = null

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    window.addEventListener("resize", this.onResize)
    this.to_date = new Date().toISOString().slice(0, 10)
    this.onUpdateFilters()
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      current_date: null,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
